import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {Attribute} from '../master-data/master-data.model';
import {MasterDataService} from '../master-data/master-data-service';

@Injectable({
  providedIn: 'root'
})
export class InstallationAttributeResolver  {
  private masterDataService = inject(MasterDataService);

  getInstallationAttributes(): Observable<Attribute[]> {
    return this.masterDataService.getInstallationAttribute();
  }
}

export const installationAttributesResolver: ResolveFn<Attribute[]> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(InstallationAttributeResolver).getInstallationAttributes();
  };
